





































































































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
import { tiposEndereco } from "@/models/cadastros/assistencia/TipoEndereco";
import { estadosList } from "@/models/cadastros/assistencia/Estados";
import { ValidationObserver } from "vee-validate";
import ClienteAdministrativoModel  from '@/models/cadastros/assistencia/ClienteAdministrativoModel';
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";

@Component
export default class ClienteAdministrativo extends Vue {
  estados = estadosList;
  tiposEnderecos = tiposEndereco;

  $refs!: {
    servicoSubClienteObserver: InstanceType<typeof ValidationObserver>;
  };

  loadingEndereco = false;
  pesquisarAlteracao = false;

clienteSynced!: ClienteAdministrativoModel | undefined;
clientesSynced: ClienteAdministrativoModel[] = [];
loadingClientes = false;
// Utilizado para o debounce manual
timerCliente: any = 0;
telefoneFormatado = "";

fnCarregaCliente(valor: ClienteAdministrativoModel) {
  this.dadosClienteAdministrativo = {};
  if (valor) {
      valor.telefone = (valor.telefones?.[0]?.ddd || "") + 
      (valor.telefones?.[0]?.numero || "");
      this.dadosClienteAdministrativo = valor;
  }
}

@Watch("dadosClienteAdministrativo.cpfCnpj")
obterClientesCpfCnpj(val: string) {
  val = (val || "").trim();

  if (val == "") {
    this.clientesSynced = [];
    this.clienteSynced = undefined;
    this.dadosClienteAdministrativo = {};
    return;
  }

  // se o campo tem menos que 3 caracteres não faz a busca
  if (val.length < 3) return;
  this.loadingClientes = true;

  // Debounce manual - LODASH não funcionou
  clearTimeout(this.timerCliente);
  this.timerCliente = setTimeout(() => {
      ServicosAssistenciaService
      .pesquisarClienteAdministrativoCpfCnpj(val)
      .then((clientes: { data: any[] }) => {
        
        //this.clientesSynced = clientes.data;
        this.clientesSynced = clientes.data.map(c => Object.assign({}, c));

      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.loadingClientes= false;
      });
  }, 300);
}

@Watch("dadosClienteAdministrativo.nome")
obterClientesNome(val: string) {
  val = (val || "").trim();

  if (val == "") {
    this.clientesSynced = [];
    this.clienteSynced = undefined;
    this.dadosClienteAdministrativo = {};
    return;
  }

  // se o campo tem menos que 3 caracteres não faz a busca
  if (val.length < 3) return;
  this.loadingClientes = true;

  // Debounce manual - LODASH não funcionou
  clearTimeout(this.timerCliente);
  this.timerCliente = setTimeout(() => {
      ServicosAssistenciaService
      .pesquisarClienteAdministrativoNome(val)
      .then((clientes: { data: any[] }) => {
        this.clientesSynced = clientes.data;
        
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.loadingClientes= false;
      });
  }, 300);
}

clienteAdministrativo: ClienteAdministrativoModel = {
      id: 0,
      nome: "",
      cpfCnpj: "",
      frota: false,
      email: "",
      endereco: undefined,
      telefones: undefined,
  };

  @Prop({ type: String, default: "" })
  title!: string;

  @PropSync("clienteAdministrativo")
  dadosClienteAdministrativo!: ClienteAdministrativoModel;

}
